import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../../utils/analytics';

/**
 * Sends a Firebase Analytics page_view on every client-side route change.
 * Paths are templated and query strings are dropped in the analytics helper.
 * Must render inside BrowserRouter.
 */
const AnalyticsRouteTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname);
  }, [location.pathname]);

  return null;
};

export default AnalyticsRouteTracker;
